module.exports = __webpack_public_path__ + "img/Virasana.3f758753.png";